import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { field } from './InfoField.less';

class InfoField extends Component {
  render() {
    const { value, children, viewStyle } = this.props;

    if (value) {
      return (
        <div className={field} style={viewStyle}>
          <h6>
            <FormattedMessage id={value} />
          </h6>
        </div>
      );
    } else {
      return (
        <div className={field} style={viewStyle}>
          {children}
        </div>
      );
    }
  }
}

InfoField.propTypes = {
  value: PropTypes.string,
  children: PropTypes.any,
  viewStyle: PropTypes.object,
};

export default InfoField;
